// entry.client.js
import createApp from './src/app.js';

const { app, router } = createApp();

router.onReady(() => {
  updateMeta(router.currentRoute);

  router.beforeEach((to, from, next) => {
    updateMeta(to);
    next();
  });

  app.$mount('#app');
});

function updateMeta(route) {
  const meta = route.meta || {};
  const defaultDescript = 'Download WA GB APK terbaru untuk Android dalam bahasa Indonesia, lengkap dengan detail versi, ukuran file, panduan instalasi, dan info risiko aplikasi pihak ketiga.'
  const defaultKeyword = 'WA GB, Download WA GB, WA GB APK, GB WhatsApp'
  document.title = meta.title || 'WA GB Terbaru - Download APK Android';
  const defaultCanonical = 'https://wagbapks.id/';

  

  setMetaTag('description', meta.description || defaultDescript);
  setMetaTag('og:description', meta.description || defaultDescript);
  setMetaTag('keywords', meta.keywords || defaultKeyword);
  setLinkTag('canonical', meta.link?.find(link => link.rel === 'canonical')?.href || defaultCanonical);

  if (meta.noindex) {
    setMetaTag('robots', 'noindex');
  } else {
    // 如果不是 noindex 页面，确保 robots 标签是默认的
    setMetaTag('robots', 'index,follow');
  }
}

function setMetaTag(name, content) {
  let element = document.querySelector(`meta[name="${name}"]`);
  if (element) {
    element.setAttribute('content', content);
  } else {
    element = document.createElement('meta');
    element.setAttribute('name', name);
    element.setAttribute('content', content);
    document.head.appendChild(element);
  }
}

function setLinkTag(rel, href) {
  let element = document.querySelector(`link[rel="${rel}"]`);
  if (element) {
    element.setAttribute('href', href);
  } else {
    element = document.createElement('link');
    element.setAttribute('rel', rel);
    element.setAttribute('href', href);
    document.head.appendChild(element);
  }
}
